import React from 'react';
import { Avatar } from 'stream-chat-react';
import UserStatusIndicator from './UserStatusIndicator';

const AvatarWithStatus = ({ 
  user, 
  size = 32, 
  showStatus = true, 
  statusSize = 'sm',
  className = '' 
}) => {
  if (!user) return null;
  
  return (
    <div className={`relative inline-block ${className}`}>
      <Avatar 
        image={user.image} 
        name={user.name || user.id} 
        size={size}
      />
      {showStatus && (
        <div className="absolute -bottom-0.5 -right-0.5">
          <UserStatusIndicator 
            userId={user.id} 
            size={statusSize}
          />
        </div>
      )}
    </div>
  );
};

export default AvatarWithStatus;